import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MasterComponent} from './component/master/master.component';
import {masterRouter} from './master.router';
import {RouterModule} from '@angular/router';
import {HeaderComponent} from '../../shared/components/header/header.component';
import {SidebarComponent} from '../../shared/components/sidebar/sidebar.component';
import {FooterComponent} from '../../shared/components/footer/footer.component';
import {MasterService} from './master.service';

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(masterRouter),
    ],
    declarations: [
        MasterComponent,
        HeaderComponent,
        SidebarComponent,
        FooterComponent
    ],
    providers: [
        MasterService
    ]
})
export class MasterModule {
}
